module.exports = __webpack_public_path__ + "static/media/wheel.00285045.png";